import { cn } from "../../utils/cn";

export interface CountBadgeProps {
  count: number;
  maxCount?: number;
  variant?: "danger" | "primary" | "success";
  size?: "sm" | "md";
  className?: string;
}

/**
 * CountBadge component for displaying unread counts or numeric indicators.
 * Optimized for positioning on top of icons or inside list items.
 */
export const CountBadge = ({
  count,
  maxCount = 99,
  variant = "danger",
  size = "md",
  className,
}: CountBadgeProps) => {
  if (count <= 0) return null;

  const displayCount = count > maxCount ? `${maxCount}+` : count;

  const variantStyles = {
    danger: "bg-[#dc2626] text-white",
    primary: "bg-primary text-primary-foreground",
    success: "bg-green-600 text-white",
  };

  const sizeStyles = {
    sm: "min-w-[16px] h-4 px-1 text-2xs",
    md: "min-w-[18px] sm:min-w-[20px] h-[18px] sm:h-5 px-1 sm:px-1.5 text-2xs sm:text-xs",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center font-semibold rounded-full transition-all duration-300",
        variantStyles[variant],
        sizeStyles[size],
        className,
      )}
    >
      {displayCount}
    </span>
  );
};
